<template>
  <div class="billManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/jianguanInventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>货物</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="inpBox">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="盘库状态:">
          <el-select v-model="formData.inventoryDetailStatus" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in inventoryDetailStatusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库时间:">
          <el-date-picker v-model="formData.inventoryTimeStart" size="mini" type="datetime" placeholder="请选择盘库时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          -
          <el-date-picker v-model="formData.inventoryTimeEnd" size="mini" placeholder="请选择盘库时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-input type="text" v-model="formData.productTypeName" size="mini" placeholder="请输入货物类型"></el-input>
        </el-form-item>
        <el-form-item label="产地:">
          <el-input type="text" v-model="formData.steelMillName" size="mini" placeholder="请输入产地"></el-input>
        </el-form-item>
        <el-form-item label="规格:">
          <el-input type="text" v-model="formData.specification" size="mini" placeholder="请输入规格"></el-input>
        </el-form-item>
        <el-form-item label="材质:">
          <el-input type="text" v-model="formData.model" size="mini" placeholder="请输入材质"></el-input>
        </el-form-item>
        <br>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="actualNumber" label="实际件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryDetailStatus" label="盘库状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.inventoryDetailStatus==0">未盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==1">已盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==2">盘库新增</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位名称" align="center"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="inventoryPerson" label="盘库人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTime" label="盘库时间" align="center" width="200"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template v-slot='scope'>
            <el-button type="text" @click="tupian(scope.row)">图片</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
        <div>
          <div class="img_box" v-for="(item,index) in imgData" :key="index">
            <el-image :src="item.url" :preview-src-list="imgList" class="tupian"></el-image>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getJGInventoryGoodsList,
  getImgShow
} from '@/api/wms-stock'
export default {
  data () {
    return {
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      formData: {
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: '',
        warehouseName: '',
        productTypeName: '',
        steelMillName: '',
        specification: '',
        model: ''
      },
      inventoryDetailStatusData: [
        {
          id: '1',
          name: '已盘'
        },
        {
          id: '0',
          name: '未盘'
        }
      ],
      total: 0,
      addMarkLookBox: false,
      imgData: [],
      inventoryMasterId: '',
      imgList: [],
      h: '500px'
    }
  },
  created () {
    this.chaxun()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 120 + 'px'
  },
  methods: {
    getJGInventoryGoodsList () {
      getJGInventoryGoodsList({
        inventoryMasterId: this.$route.query.inventoryMasterId,
        ...this.formData,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getJGInventoryGoodsList()
    },
    chongzhi () {
      this.formData = {
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: '',
        warehouseName: '',
        productTypeName: '',
        steelMillName: '',
        specification: '',
        model: ''
      }
      this.chaxun()
    },
    tupian (row) {
      this.addMarkLookBox = true
      getImgShow({
        businessId: row.inventoryDetailId,
        businessType: 'inventory_picture'
      }).then(res => {
        console.log(res)
        this.imgData = res
        this.imgList = res.map(item => item.url)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  margin-top: 15px;
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.addMarkBox {
  .noImg {
    text-align: center;
  }
}
.img_box {
  width: 150px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width: 100%;
    height: 100%;
  }
}
</style>
